import moment from "moment-timezone";

function dateFormat(date: string | number | Date) {
  const d = new Date(date);
  const dm = moment(d);
  return dm.format("DD.MM.YYYY");
}

function dateFormatIso(date: string | number | Date) {
  const d = new Date(date);
  const dm = moment(d);
  return dm.format("YYYY-MM-DD");
}

export function useDateFormat() {
  return {
    dateFormat,
    dateFormatIso,
  };
}
